export default __webpack_public_path__ + "static/insured-event-8267835593af02379ff374c6e59b654e.png";